// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"234":"2b536744","252":"b7135c20"}[chunkId] + ".chunk.css");